export const PERMISSIONS = {
  ad_management: "ad_management",
  reporting: "reporting",
  ai_front_desk: "ai_front_desk",
  fsm: "fsm",
  TEAM_MANAGEMENT: "TEAM_MANAGEMENT",
};
